import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const GlossIcon = ({ className, color = Color.White }: NewIconProps) => (
  <svg
    className={twMerge('size-[9px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.10027 0.820659C8.47549 0.996109 8.63743 1.44251 8.46198 1.81774C7.01547 4.91128 4.4517 7.37688 1.28862 8.69595C0.906318 8.85538 0.467158 8.6747 0.307731 8.2924C0.148303 7.9101 0.328979 7.47094 0.711282 7.31151C3.52866 6.13661 5.81436 3.93871 7.10319 1.18238C7.27864 0.807157 7.72505 0.64521 8.10027 0.820659Z"
      fill={color}
      fillOpacity="0.4"
    />
  </svg>
);
